<template>
    <div @click="onEventClick" :class="['client-wrapper', {'dark': currentEvent && currentEvent.id === event.id}]">
        <template  v-if="event.client">

            <v-subheader class="client-title ">
                <v-chip small outlined color="primary">
                    <v-icon size="15" class="mr-2">fa-clock</v-icon>
                    {{event.time}}
                </v-chip>
                <event-status-chip class="ml-1" v-if="event.event_status" :event-status="event.event_status" />
                <v-tooltip top v-if="event.extra">
                    <template v-slot:activator="{ on }">
                        <v-avatar color="blue-grey  ml-1" size="25">
                            <v-icon color="white" size="13" dark v-on="on">fas fa-calendar-plus</v-icon>
                        </v-avatar>
                    </template>
                    <span>Cupo extra</span>
                </v-tooltip>
                <v-tooltip top v-if="event.type === 'video'">
                    <template v-slot:activator="{ on }">
                        <v-avatar color="black  ml-1" size="25">
                            <v-icon color="white" size="13" dark v-on="on">fas fa-video</v-icon>
                        </v-avatar>
                    </template>
                    <span>Video Llamada</span>
                </v-tooltip>
                <v-spacer></v-spacer>
            </v-subheader>

            <v-list-item >

                <v-icon
                        v-if="currentEvent && currentEvent.id === event.id"
                        size="12"
                        class="mr-2"
                        color="accent">fa-circle</v-icon>

                <v-list-item-avatar size="45">
                    <img :src="event.client && event.client.avatar || getFakeAvatar(event.client.gender)">
                </v-list-item-avatar>


                <v-list-item-content>
                    <v-list-item-title>{{event.client.first_name}} {{event.client.last_name || ''}}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{details}}
                      <elapsed-time prepend-label="Llegó hace" v-if="event.event_status_id === 3" :start-at="event.arrived_at" />
                    </v-list-item-subtitle>
                </v-list-item-content>

            </v-list-item>

        </template>

        <template v-else>
            <v-subheader class="client-title ">
                <v-chip small outlined color="primary">
                    <v-icon size="15" class="mr-2">fa-clock</v-icon>
                    {{event.time}}
                </v-chip>
                <v-chip small readonly outlined color="red">
                    <v-icon size="15" class="mr-2">fa-ban</v-icon>
                    Cancelada
                </v-chip>
                <v-tooltip top v-if="event.extra">
                    <template v-slot:activator="{ on }">
                        <v-avatar color="blue-grey  ml-1" size="25">
                            <v-icon color="white" size="13" dark v-on="on">fas fa-calendar-plus</v-icon>
                        </v-avatar>
                    </template>
                    <span>Cupo extra</span>
                </v-tooltip>
                <v-tooltip top v-if="event.type === 'video'">
                    <template v-slot:activator="{ on }">
                        <v-avatar color="black  ml-1" size="25">
                            <v-icon color="white" size="13" dark v-on="on">fas fa-video</v-icon>
                        </v-avatar>
                    </template>
                    <span>Video Llamada</span>
                </v-tooltip>
            </v-subheader>

            <v-list-item  v-if="lastCancelledEvent.client">

                <v-icon
                        v-if="currentEvent && currentEvent.id === event.id"
                        size="12"
                        class="mr-2"
                        color="accent">fa-circle</v-icon>

                <v-list-item-avatar size="45">
                    <img :src="lastCancelledEvent.client.avatar || getFakeAvatar(lastCancelledEvent.client.gender)">
                </v-list-item-avatar>


                <v-list-item-content>
                    <v-list-item-title>{{lastCancelledEvent.client.first_name}} {{lastCancelledEvent.client.last_name || ''}}</v-list-item-title>
                    <v-list-item-subtitle>{{details}}</v-list-item-subtitle>
                </v-list-item-content>

            </v-list-item>
        </template>

    </div>
</template>

<script>

    import EventStatusChip from '@/components/appointments/EventStatusChip'
    import {getFakeAvatar} from '@/utils/Common'
    import {getEventCancelReason} from '@/utils/Strings'

    import {mapState} from 'vuex'
    import ElapsedTime from "@/components/appointments/attention/ElapsedTime";

    export default{
        props: ['event'],
        components: {ElapsedTime, EventStatusChip},
        mounted(){ },
        data(){
            return { }
        },
        methods: {
            getFakeAvatar,
            onEventClick(){
                var vm = this
                if(!vm.event || !vm.event.client) return
                vm.$emit('click:appointment', vm.event)

            }
        },
        computed: {
            ...mapState('clientAttention', {
                currentEvent: state => state.currentEvent
            }),
            lastCancelledEvent(){
                var vm = this
                if(
                        !vm.event.cancelled_events ||
                        vm.event.cancelled_events.length === 0 ||
                        !vm.event.cancelled_events[0].client
                ){
                    return null
                }

                const sorted = vm.event.cancelled_events.filter(evt => evt.client)
                .sort((a,b) => {
                    return b.id - a.id
                })

                var lastCancelledEvents = sorted[0]
                lastCancelledEvents.reason = getEventCancelReason(lastCancelledEvents.reason)

                return sorted[0]

            },

            details(){
                var vm = this
                const event = vm.event

                if(!event.client && vm.lastCancelledEvent){
                    return getEventCancelReason(vm.lastCancelledEvent.reason)
                }

                return ''

            }

        },
        watch: {
            event(val){
                var vm = this
            }
        }
    }
</script>

<style scoped>

    .client-title{
        height: 10px;
        margin-top: 20px;
    }

    .client-wrapper{
        transition: all .2s;
    }

    .client-wrapper:hover{
        transform: scale(1.03);
        cursor: pointer;
    }


</style>
